export default async function GetOnHoldTasksApi(perfCycleId, positionId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/on-hold?perfCycleId=${perfCycleId}&positionId=${positionId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error fetching on-hold tasks: ", error);
        res = { success: false, data: {} };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, data: {} };
  }

  return res;
}
